import React, { useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import useAuthEffect from "../../hook/useAuthEffect";
import { useSelector } from "react-redux";
import { fetchMemories } from "../../redux/ducks/memory";
import useEffectWithoutLoad from "../../hook/useEffectWithoutLoad";
import useStatusThunk from "../../hook/useStatusThunk";
import { mapData } from "../../helpers/mapRow";
import { Table } from "../../components/dumb/DataTable";
import CreateMemory from "../../components/smart/buttonPopups/CreateMemory";
import DeleteMemory from "../../components/smart/buttonPopups/DeleteMemory";

const MemoriesRoute = () => {
    const memories = useSelector(state => state.memory.memories);
    const [rows, setRows] = useState([]);
    const [dispatchFetchMemories, status, error] = useStatusThunk(fetchMemories);

    //Fetch memories
    useAuthEffect(isAuth => dispatchFetchMemories());

    useEffectWithoutLoad(() => {
        if (status == "success") setRows(mapData(memories));
    }, [status, memories]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="memories" />
            </div>

            <div className="column column--primary">
                <Memories rows={rows} />
            </div>
        </div>
    )
}


const Memories = props => {

    const memoryURL = "/PM/memory/view/:memoryID";

    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: memoryURL.replace(":memoryID", row.ID) })}
            {renderData(row.note, { key: "note" })}
            {renderData(row.sourceLang, { key: "sourcelang" })}
        </React.Fragment>

    let titleContent = <React.Fragment>
        <DeleteMemory memoryID={checkValues[0]} className={checkValues.length == 1 ? "" : "button--disabled"} />
        <CreateMemory />
    </React.Fragment>

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title="Memories" titleContent={titleContent} renderRow={renderRow} rows={props.rows} cols={[
            { name: "id", sortCol: "ID" },
            { name: "name", sortCol: "name" },
            { name: "note", sortCol: "note" },
            { name: "source lang", sortCol: "sourceLang" }
        ]} />
    )
}


export default MemoriesRoute;